var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHibernate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2397,
    height: 2500,
    viewBox: "0 0 256 267",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.671 178.933l-.932 2.757 49.137 83.342 2.781 1.968L256 178.22l-51.342-89.137-50.986 89.85zM50.273.304L0 89.084l52.234 89.849 49.738-89.85-.134-3.63L52.565 2.11 50.273.304z",
    fill: "#59666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.273.304l51.7 88.78h102.684L152.601.304H50.273zM52.234 178.933L102.864 267h101.793l-50.986-88.067H52.234z",
    fill: "#BCAE79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernate);
export default __webpack_public_path__ + "static/media/hibernate.3ba27e0b6fd7445e70b782fe6cb5aed4.svg";
export { ForwardRef as ReactComponent };